<template>
  <div class="timeChange">
    <div class="sellerdata-day-data" @click="nearDateClick">
      <div class="nearMoutn">
        <span>{{ mouthText }}</span>
        <div class="nearMouth-list" v-if="nearType">
          <div
            class="nearMouth-list-item"
            v-for="(item, index) in mouthDate"
            @click="selectMouth(item)"
            :key="index"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <span class="nearBot">▼</span>
      <div class="weeks" v-if="weeksIf">第{{ weekNumber }}周</div>
    </div>
    <div class="car-day-data sellerDaydata">
      <div
        @click="prevMouth"
        style="color: #1eb6ff; border-radius: 0 0 0 0"
        class="dateBtn"
      >
        ◀
      </div>
      <el-date-picker
        v-model="chooseMouth"
        :type="dateTypes"
        range-separator="—"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :format="mouthFormat"
        @change="chooseMouths"
        :clearable="false"
        :value-format="valueFormat"
      >
      </el-date-picker>
      <div
        @click="nextMouth"
        style="color: #1eb6ff; border-radius: 0 15px 15px 0"
        class="dateBtn"
      >
        ▶
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    timeData: {
      typeTimeC: {
        type: Number,
      },
    },
  },
  data() {
    return {
      // 日历类型
      dateTypes: "daterange",
      // 月份格式
      mouthFormat: "yyyy-MM",
      // 日期数据格式
      valueFormat: "yyyy-MM",
      chooseMouth: "",
      mouthText: "近12个月",
      mouthRange: 12,
      nearType: false,
      // 判断传入id
      typeTimeC: 1,
      // 判断是否显示第几周
      weeksIf: false,
      // 选择月份
      mouthDate: [
        { id: 1, title: "自然年" },
        { id: 2, title: "自然月" },
        { id: 3, title: "自然周" },
        { id: 4, title: "近12个月" },
        { id: 5, title: "近30日" },
        { id: 6, title: "近7日" },
      ],
    };
  },
  computed: {
    weekNumber() {
      const dates = this.chooseMouth[0];
      const date = new Date(dates);
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const firstDayOfWeek = firstDayOfYear.getDay() || 7;
      const offset = firstDayOfWeek > 4 ? 1 : 0;
      const dayOfYear =
        Math.floor((date - firstDayOfYear + firstDayOfWeek) / 86400000) + 1;
      const weekNumber = Math.floor((dayOfYear - 1) / 7) + 1 + offset;
      return weekNumber;
    },
  },
  mounted() {
    let currentDate = new Date();
    this.mouthText = this.mouthDate.find(
      (item) => item.id == this.timeData.typeTimeC
    ).title;
    this.chooseMouth = this.calculateInterval(
      currentDate,
      this.timeData.typeTimeC,
      "prev"
    );
    this.typeTimeC = this.timeData.typeTimeC;
  },

  methods: {
    // 计算日期
    calculateInterval(day, type, dire) {
      this.dateTypes = "daterange";

      // 计算传入日期
      let currentDate = new Date(day);
      // 获取当前年、月、日
      let nowYear = currentDate.getFullYear();
      let nowMonth = currentDate.getMonth() + 1; // 返回值为 0-11，需要加 1
      // const nowDay = currentDate.getDay();
      let nowDay = currentDate.getDate();
      // 如果传入为自然年
      if (type == 1) {
        this.weeksIf = false;
        // 获取去年
        let lastYear = currentDate.getFullYear() - 1;

        this.mouthFormat = "yyyy-MM";
        this.valueFormat = "yyyy-MM";
        this.dateTypes = "monthrange";

        if (dire == "prev") {
          let beforeLastYear = currentDate.getFullYear() - 1;
          return [beforeLastYear + "-01", beforeLastYear + "-12"];
        } else if (dire == "next") {
          let nextYear = currentDate.getFullYear() + 1;
          return [nextYear + "-01", nextYear + "-12"];
        } else {
          return [lastYear + "-01", lastYear + "-12"];
        }
      }

      // 如果出入为自然月
      if (type == 2) {
        let startDate, endDate;
        this.weeksIf = true;
        this.mouthFormat = "MM/dd";
        this.valueFormat = "MM/dd";
        if (dire == "prev") {
          // 上个月的第一天和最后一天
          startDate = new Date(nowYear, nowMonth - 2, 1);
          endDate = new Date(nowYear, nowMonth - 1, 0);
        } else if (dire == "next") {
          // 下个月的第一天和最后一天
          startDate = new Date(nowYear, nowMonth, 1);
          endDate = new Date(nowYear, nowMonth + 1, 0);
        } else {
          // 当前月的第一天和最后一天
          startDate = new Date(nowYear, nowMonth - 1, 1);
          endDate = new Date(nowYear, nowMonth, 0);
        }

        let startDay = startDate.getDate();
        let endDay = endDate.getDate();

        let startMonth = startDate.getMonth() + 1;
        let endMonth = endDate.getMonth() + 1;

        let startYear = startDate.getFullYear();
        let endYear = endDate.getFullYear();
        let startDateStr =
          (startMonth < 10 ? "0" + startMonth : startMonth) +
          "/" +
          (startDay < 10 ? "0" + startDay : startDay);
        let endDateStr =
          (endMonth < 10 ? "0" + endMonth : endMonth) +
          "/" +
          (endDay < 10 ? "0" + endDay : endDay);
        return [startDateStr, endDateStr];
      }

      // 如果输出为自然周
      if (type == 3) {
        let startDate, endDate;
        this.weeksIf = true;

        this.mouthFormat = "MM-dd";
        this.valueFormat = "MM-dd";
        if (dire == "prev") {
          // 当前日期的星期几（星期一为 1，星期日为 0）
          const currentDayOfWeek = new Date(
            nowYear,
            nowMonth - 1,
            nowDay
          ).getDay();
          // 上一周的星期一和星期日
          startDate = new Date(
            nowYear,
            nowMonth - 1,
            nowDay - currentDayOfWeek - 6
          );
          endDate = new Date(nowYear, nowMonth - 1, nowDay - currentDayOfWeek);
        } else if (dire == "next") {
          // 下一周的星期一和星期日
          startDate = new Date(nowYear, nowMonth - 1, nowDay + 1);
          endDate = new Date(nowYear, nowMonth - 1, nowDay + 7);
        }
        let startDay = startDate.getDate();
        let endDay = endDate.getDate();

        let startMonth = startDate.getMonth() + 1;
        let endMonth = endDate.getMonth() + 1;

        let startYear = startDate.getFullYear();
        let endYear = endDate.getFullYear();
        let startDateStr =
          (startMonth < 10 ? "0" + startMonth : startMonth) +
          "-" +
          (startDay < 10 ? "0" + startDay : startDay);
        let endDateStr =
          (endMonth < 10 ? "0" + endMonth : endMonth) +
          "-" +
          (endDay < 10 ? "0" + endDay : endDay);
        return [startDateStr, endDateStr];
      }

      // 如果传入近12个月
      if (type == 4) {
        let startDate, endDate;
        this.weeksIf = false;

        this.mouthFormat = "yyyy-MM";
        this.valueFormat = "yyyy-MM";
        this.dateTypes = "monthrange";

        if (dire == "prev") {
          startDate = new Date(nowYear, nowMonth - 12, 1);
          endDate = new Date(nowYear, nowMonth - 1, 1);
        } else if (dire == "next") {
          startDate = new Date(nowYear, nowMonth, 1);
          endDate = new Date(nowYear, nowMonth + 11, 1);
        }
        let startMonth = startDate.getMonth() + 1;
        let endMonth = endDate.getMonth() + 1;

        let startYear = startDate.getFullYear();
        let endYear = endDate.getFullYear();
        let startDateStr =
          startYear + "-" + (startMonth < 10 ? "0" + startMonth : startMonth);
        let endDateStr =
          endYear + "-" + (endMonth < 10 ? "0" + endMonth : endMonth);
        return [startDateStr, endDateStr];
      }

      // 近30日
      if (type == 5) {
        let startDate, endDate;
        this.weeksIf = false;

        this.mouthFormat = "yyyy-MM-dd";
        this.valueFormat = "yyyy-MM-dd";
        if (dire == "prev") {
          startDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 30
          );
          endDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 1
          );
        } else if (dire == "next") {
          startDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 1
          );
          endDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 30
          );
        }

        let startYear = startDate.getFullYear();
        let startMonth = startDate.getMonth() + 1;
        let startDay = startDate.getDate();
        let endYear = endDate.getFullYear();
        let endMonth = endDate.getMonth() + 1;
        let endDay = endDate.getDate();

        let startDateStr = `${startYear}-${
          startMonth < 10 ? "0" + startMonth : startMonth
        }-${startDay < 10 ? "0" + startDay : startDay}`;
        let endDateStr = `${endYear}-${
          endMonth < 10 ? "0" + endMonth : endMonth
        }-${endDay < 10 ? "0" + endDay : endDay}`;

        return [startDateStr, endDateStr];
      }

      // 近七日
      if (type == 6) {
        let startDate, endDate;
        this.weeksIf = false;

        this.mouthFormat = "yyyy-MM-dd";
        this.valueFormat = "yyyy-MM-dd";
        if (dire == "prev") {
          startDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 7
          );
          endDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 1
          );
        } else if (dire == "next") {
          startDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 1
          );
          endDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 7
          );
        } else {
          startDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 7
          );
          endDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate()
          );
        }

        let startYear = startDate.getFullYear();
        let startMonth = startDate.getMonth() + 1;
        let startDay = startDate.getDate();
        let endYear = endDate.getFullYear();
        let endMonth = endDate.getMonth() + 1;
        let endDay = endDate.getDate();

        let startDateStr = `${startYear}-${
          startMonth < 10 ? "0" + startMonth : startMonth
        }-${startDay < 10 ? "0" + startDay : startDay}`;
        let endDateStr = `${endYear}-${
          endMonth < 10 ? "0" + endMonth : endMonth
        }-${endDay < 10 ? "0" + endDay : endDay}`;

        return [startDateStr, endDateStr];
      }
    },
    // 选择月份下拉
    selectMouth(res) {
      this.mouthText = res.title;
      let currentDate = new Date();
      this.typeTimeC = res.id;
      this.chooseMouth = this.calculateInterval(currentDate, res.id, "prev");
      this.$emit("dayTimeData", this.chooseMouth);
    },
    // 选择月份
    chooseMouths(res) {
      this.chooseMouth = res;
    },
    //销售趋势下拉
    nearDateClick() {
      this.nearType = !this.nearType;
      // 改变父组件传来的值也会同步改变
    },
    prevMouth() {
      this.chooseMouth = this.calculateInterval(
        this.chooseMouth[0],
        this.typeTimeC,
        "prev"
      );
    },
    nextMouth() {
      this.chooseMouth = this.calculateInterval(
        this.chooseMouth[1],
        this.typeTimeC,
        "next"
      );
    },
  },
};
</script>

<style scoped>
.weeks {
  -webkit-text-fill-color: #1eb6fe;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: #000c3e;
  margin-left: 10px;
}
/deep/ .el-date-editor .el-range-separator {
  line-height: 2.6vh;
  width: 17%;
  font-size: 12px;
}
.nearBot {
  border-right: 2px solid #13c9ff;
  display: inline-block;
  padding: 0 15px 0 10px;
  font-size: 12px;
  line-height: 10px;
  height: 10px;
}
.timeChange {
  display: flex;
  align-items: center;
}
.dateBtn {
  padding: 0 5px;
  font-size: 12px;
  width: 20px;
  height: 30px;
  -webkit-text-fill-color: #1db6ff;

  text-align: center;
  line-height: 28px;
  cursor: pointer;
  background: #000c3e;
}
.dateBtn:hover {
  color: #13c9ff !important;
}
.sellerdata-day-data {
  margin-left: 20px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  border-radius: 15px 0 0 15px;
  padding: 0 5px 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #000c3e;
  -webkit-text-fill-color: #1eb6fe;
  font-weight: 400;
}
.nearMouth-list {
  position: absolute;
  background: #0d1566;
  padding: 0 15px;
  margin-top: 6px;
  margin-right: 5px;
  border: 1px solid #084ab7;
  z-index: 10;

  -webkit-text-fill-color: #53abdf;
}
.nearMouth-list-item {
  margin: 10px 0;
  color: #53abdf;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.nearMouth-list-item:hover {
  -webkit-text-fill-color: #13c9ff;
}
.sellerdata-text .car-day-data {
  -webkit-text-fill-color: #1eb6fe;
}
/deep/.car-day-data .el-input__inner {
  background: #000c3e !important;
  padding: 3px 0;
  text-align: center;
  height: 30px;
  /* width: 100px; */
  color: #1db6ff;
  -webkit-text-fill-color: #1db6ff;
  border: 0 !important;
  border-radius: 0 !important;
}
/deep/.car-day-data .el-input__prefix {
  display: none;
}
/deep/ .car-day-data .el-input--prefix .el-input__inner {
  padding-left: 0;
  height: 30px;
}
/deep/ .car-day-data .el-input--suffix .el-input__inner {
  padding-right: 0;
}
.car-day-data {
  display: flex;
  width: 50%;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/timeChange.vue